export default {
    SET_FULFILLMENT_TABLE: (state, fulfillmentTable) => {
        state.fulfillmentTable = fulfillmentTable;
    },
    UPDATE_FULFILLMENT: (state, fulfillment) => {
        state.fulfillmentTable[fulfillment.user.code] = fulfillment;
    },
};
